import { actions, selectors } from 'data'
import { connect } from 'react-redux'

import Notifications from './template'

const mapStateToProps = (state) => ({
  data: selectors.app.getNotifications(state)
})

const mapDispatchToProps = (dispatch) => ({
  onClose: (notification) => {
    dispatch(actions.app.removeNotif(notification.id))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(Notifications)
